<ul sd-list-block class="is-s" data-testid="links-list">
  @for (link of links; track link) {
    <li #linksList>
      <button (click)="selectLink(link?.url, link?.linkName, $event)"  data-testid="link-element"
        (keydown.enter)="selectLink(link?.url, link?.linkName, $event)"
        tabindex="0"
        [sdSpyOn]="link?.url"
        (isActivated)="chosenLink.emit(link?.linkName)"
        activeClass="is-active"
        class="is-reset is-medium c__anchor-button is-body-s"
      >
        <span class="{{isOpened ? 'is-visible' : 'is-visually-hidden'}}" data-testid="link-name">
          {{link?.linkName}}
        </span>
      </button>
    </li>
  }
</ul>

<button sd-button
  [isIcon]="!isOpened"
  [isSmall]="true"
  (click)="toggleMenu()"
  [icon]="isOpened ? 'icon-arrow-left' : 'icon-arrow-right'"
  data-testid="toggle-button"
>
  <span class="{{isOpened ? '' : 'is-visually-hidden'}}" data-testid="close-span">
    {{ 'actions.close' | translate }}
  </span>
</button>
